declare module 'vue-router' {
  interface RouteMeta {
    pageTitle?: string;
    requireOkta?: boolean;
  }
}

export enum RouteNames {
  MAIN_CONTENT = 'MainContent',
  SOCIAL_LANDING_PAGE = 'SocialLandingPage',
  NOT_FOUND = 'NotFound',
}
